<template>
  <div class="order-box">
      <ul>
      <li>
        <div class="Order">
          <p> <b>订单名称：{{item.orderInfo.orderName}}</b></p>
          <p>订单编号：{{item.orderInfo.orderNo}}</p>
          <p><b>缴费时间：{{item.orderInfo.payTime}}</b></p>
          <p :class="{'order-title': item.orderInfo.orderStatus == 2}" :title="item.orderInfo.orderName">
          <b>缴费金额：<i>￥{{item.orderInfo.amount}}</i></b>
          <span :class="{success: item.statue == 5}">状态：<i>{{item.orderInfo.invoiceStatus | invoiceStatue}}</i></span>
          </p>
        </div>
        <div v-if="item.orderInfo.invoiceStatus==const_invoice_status_no && item.orderInfo.orderStatus>3" class="buttonBox">
            <van-button type="info" plain block  @click="applyInvoice(item)">申请开票</van-button>
        </div>
      </li>
      </ul>
  </div>
</template>

<script>
import { getPZUrl, paymentCancel, cancelMeetingOrder } from "@/api/dictionary";
import { Uploader,Toast,Button,ImagePreview,Dialog } from "vant";
import {setSessionStore} from "@/utils/sessionStorage.js"


export default {
  data() {
    return {
      PZUrl: "",
      const_invoice_status_no: 1,
    };
  },
  props: {
    item: {
      type: Object,
      default: () => {}
    },
    from: {
      type: String,
      default: ""
    },
    isWXPay: {
      type: Boolean,
      default: true
    }
  },
  filters: {
    invoiceStatue(val) {
        switch (val) {
            case 1:
                return "未申请";
                bredk;
            case 2:
                return "申请中";
                bredk;
            case 3:
                return "已开票";
                bredk;
        }
    }
  },
  components: {
    [Uploader.name]: Uploader,
    [Toast.name]: Toast,
    [Button.name]: Button,
    [ImagePreview.name]: ImagePreview,
    [Dialog.name]: Dialog,
  },
  methods: {
    go(pathName) {
        console.log(this.item);
        let params = {};
        params.orderId = this.item.orderInfo.id;
        this.$router.push({ name: pathName ,query:params});
    },
    show() {
      const viewer = this.$el.querySelector(".images").$viewer;
      viewer.show();
    },
    onLine() {
      this.$emit("onLine", this.item.orderInfo);
    },
    underLine() {
      this.$router.push({
        name: "payUndeLine",
        params: { id: this.item.orderInfo.id },
        query: { form: this.from }
      });
    },
    cancel() {
      let params = {
        orderId: this.item.orderInfo.id
      };
    Dialog.confirm("确认删除订单?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
      // on confirm
      if (this.from == "meetingUndeLine") {
            this.meetingCancel(params);
          } else {
            this.paymentCancel(params);
          }
    }).catch(() => {
      // on cancel
    });
    },
    paymentCancel(params) {
      paymentCancel(params).then(res => {
        Toast.success("取消成功！");
        this.$emit("getDate", this.item);
      });
    },
    meetingCancel(params) {
      cancelMeetingOrder(params).then(res => {
        if (res.success) {
          this.$emit("getDate", this.item);
        } else {
          Toast.fail("创建订单失败");
        }
      });
    },
    deleteOrder() {
      let params = {
        meetingId: this.item.meeting.id,
        memberId: sessionStorage.getItem("memberId")
      };

      this.$confirm("确认删除订单?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          deleteMeetingOrder(params).then(res => {
            if (res.success) {
              this.$emit("update");
            } else {
              Toast.fail("创建订单失败");
            }
          });
        })
        .catch(() => {});
    },
    //获取凭证
    getDisplay(offlineVoucher) {
      let params = {
        id: offlineVoucher
      };

      if (!offlineVoucher) return;

      getPZUrl(params).then(res => {
        if (res.success) {
          this.PZUrl = res.result;
        }
      });
    },
     applyInvoice(item){
        setSessionStore("invoice",JSON.stringify(item));
        this.$router.push({path:"/applyInvoice"});
     }
  },
  mounted() {
    this.getDisplay(this.item.orderInfo.offlineVoucher);
  }
};
</script>

<style scoped lang="less">

.content ul li{ 
  border-bottom:#f3f6fb solid 14px ;
    p{
      overflow: hidden; padding:0 20px;  line-height: 32px; color: #666; font-size: 15px;
      b{ float: left; display: block; line-height: 28px; }
      span{ 
        display: block; 
        float: right;
        font-size: 14px;
        line-height: 28px;
        i{
          color: #ea4848;
         }
        }
     }
    }
 .Order{ background: #fff; padding: 20px 0;}
 .Order b i{ font-size: 18px; color: red;}
.fontsBox{ 
  width: 84%;
  margin:20px auto 0 auto;
  background: #fff6ec; 
  padding:14px; 
  font-size: 13px;
  border: #f6d0a2 dashed 1px;
  line-height: 22px;
  color: #ffbe4e;
}
.imgBox{ 
  padding:20px; 
    img{ width: 100%; }
} 
/deep/.van-nav-bar .van-icon{
  color: #fff;
}
.buttonBox{
  overflow: hidden;
  background: #fff;
  padding:0 20px; margin:20px 0
}
.van-button--plain.van-button--primary,.van-button--info{  border:1px solid #228ccd !important;}
.images{ margin-left: 20px; }
.voucher img{ width:80px; height: 30px; }
</style>


